import { computeIndicators, type IndicatorSeries } from "./indicators";
import type { IndicatorLine } from "./CandleChart";
import type { Bar } from "../api/client";

// Shared palette + pane assignments for the bar-derived indicators. Used on
// both the per-decision replay view and the per-day symbol view so the two
// charts read identically. Edit here once instead of in every page.

export const INDICATOR_PALETTE: Record<string, string> = {
  ret_1: "#60a5fa",
  ret_12: "#3b82f6",
  ret_48: "#1d4ed8",
  rv_12: "#f59e0b",
  rv_48: "#d97706",
  atr_norm: "#a78bfa",
  dist_vwap: "#ec4899",
  tod_sin: "#10b981",
  tod_cos: "#059669",
};

// Pane assignments:
//  - Default pane 1 holds the small-magnitude indicators (returns, vol,
//    atr, dist_vwap) which all live within ±0.05 and read fine on a
//    shared axis.
//  - Pane 2 isolates time-of-day sin/cos — they oscillate in [-1, +1],
//    a ~20x larger range than the returns, and would flatten every other
//    line on the shared axis.
export const INDICATOR_PANE: Record<string, number> = {
  tod_sin: 2,
  tod_cos: 2,
};

export function buildIndicatorLines(series: IndicatorSeries | undefined): IndicatorLine[] {
  if (!series) return [];
  return Object.entries(INDICATOR_PALETTE)
    .map(([key, color]): IndicatorLine | null => {
      const arr = series[key as keyof IndicatorSeries] as (number | null)[] | undefined;
      if (!arr) return null;
      return { key, color, values: arr, paneIndex: INDICATOR_PANE[key] ?? 1 };
    })
    .filter((x): x is IndicatorLine => x !== null);
}

export function buildIndicatorLinesFromBars(bars: Bar[] | undefined): IndicatorLine[] {
  if (!bars || bars.length === 0) return [];
  return buildIndicatorLines(computeIndicators(bars));
}
